import { createAction, props } from "@ngrx/store";
import { User } from "../../models/user.model";

export const ADD_USER = '[User] Add user';
export const ADD_USER_SUCCESS = '[User] Add user success';
export const ADD_USER_FAIL = '[User] Add user fail';
export const DELETE_USER = '[User] Delete user';
export const DELETE_USER_SUCCESS = '[User] Delete user success';
export const DELETE_USER_FAIL = '[User] Delete user fail';
export const UPDATE_USER = '[User] Update user';
export const UPDATE_USER_SUCCESS = '[User] Update user success';
export const UPDATE_USER_FAIL = '[User] Update user fail';

export const AddUserAction = createAction(
    ADD_USER,
    props<{ data: User }>()
);

export const AddUserSuccessAction = createAction(
    ADD_USER_SUCCESS,
    props<{ data: User }>()
);

export const AddUserFailAction = createAction(
    ADD_USER_FAIL,
    props<{ error: Error }>()
);

export const DeleteUserAction = createAction(
    DELETE_USER
);

export const DeleteUserSuccessAction = createAction(
    DELETE_USER_SUCCESS
);

export const DeleteUserFailAction = createAction(
    DELETE_USER_FAIL,
    props<{ error: Error }>()
);

export const UpdateUserAction = createAction(
    UPDATE_USER,
    props<{ data: User }>()
);

export const UpdateUserSuccessAction = createAction(
    UPDATE_USER_SUCCESS,
    props<{ data: User }>()
);

export const UpdateUserFailAction = createAction(
    UPDATE_USER_FAIL,
    props<{ error: Error }>()
);
